import React, { Component } from "react";
import {
  Container,
  Box,
  TextField,
  Button,
  Paper,
  Typography,
  Card,
  CardContent,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import IconButton from "@material-ui/core/IconButton";
import { withFirebase } from "../Firebase";
import MercadoPagoService from "../../services/MercadoPagoService";
import { compose } from "recompose";
import { NotificationManager } from "react-notifications";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputMask from "react-input-mask";
import AddressAutocomplete from "./AddressAutocomplete";

const styles = (theme) => ({
  root: {
    minHeight: "100vh",
    background: "#f5f5f5",
    padding: theme.spacing(4, 0),
  },
  container: {
    maxWidth: 1000,
  },
  section: {
    marginBottom: theme.spacing(3),
  },
  sectionTitle: {
    fontSize: "1.3rem",
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
    color: "#0d47a1",
  },
  paper: {
    padding: theme.spacing(3),
    borderRadius: "12px",
  },
  productGrid: {
    marginBottom: theme.spacing(2),
  },
  productCard: {
    cursor: "pointer",
    transition: "all 0.3s ease",
    border: "2px solid transparent",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 8px 16px rgba(0, 0, 0, 0.15)",
      borderColor: "#1976d2",
    },
  },
  productCardSelected: {
    borderColor: "#0d47a1",
    background: "#e3f2fd",
  },
  productCardContent: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  productInfo: {
    flex: 1,
  },
  productActions: {
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(1),
  },
  quantityControl: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    background: "#f5f5f5",
    borderRadius: "20px",
    padding: "2px 8px",
  },
  quantityButton: {
    padding: 6,
    background: "#0d47a1",
    color: "white",
    "&:hover": {
      background: "#1976d2",
    },
  },
  quantityText: {
    minWidth: 30,
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "1rem",
  },
  addButton: {
    background: "#0d47a1",
    color: "white",
    padding: 8,
    "&:hover": {
      background: "#1976d2",
    },
  },
  fixedBottomBar: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    background: "white",
    boxShadow: "0 -4px 12px rgba(0, 0, 0, 0.1)",
    padding: theme.spacing(2),
    zIndex: 1000,
  },
  fixedBottomButton: {
    background: "linear-gradient(135deg, #0d47a1 0%, #1976d2 100%)",
    color: "white",
    padding: theme.spacing(2),
    fontSize: "1.1rem",
    fontWeight: "bold",
    textTransform: "none",
    borderRadius: "8px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "&:disabled": {
      background: "#ccc",
      color: "#666",
    },
  },
  contentPadding: {
    paddingBottom: 100,
  },
  cartItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1.5),
    background: "#f9f9f9",
    borderRadius: "8px",
    marginBottom: theme.spacing(1),
  },
  totalBox: {
    background: "linear-gradient(135deg, #0d47a1 0%, #1976d2 100%)",
    color: "white",
    padding: theme.spacing(2),
    borderRadius: "8px",
    textAlign: "center",
    marginTop: theme.spacing(2),
  },
  totalAmount: {
    fontSize: "1.8rem",
    fontWeight: "bold",
  },
  submitButton: {
    background: "linear-gradient(135deg, #0d47a1 0%, #1976d2 100%)",
    color: "white",
    padding: theme.spacing(1.5),
    fontSize: "1rem",
    fontWeight: "bold",
    textTransform: "none",
    borderRadius: "8px",
    marginTop: theme.spacing(2),
    "&:hover": {
      background: "linear-gradient(135deg, #0d3b7f 0%, #1565c0 100%)",
      transform: "translateY(-2px)",
      boxShadow: "0 8px 16px rgba(13, 71, 161, 0.3)",
    },
    "&:disabled": {
      background: "#ccc",
      color: "#999",
    },
  },
  textField: {
    marginBottom: theme.spacing(2),
  },
  quantityInput: {
    maxWidth: 80,
  },
});

class CustomerCheckoutBase extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phonenumber: "",
      address: "",
      complement: "",
      products: [],
      cartItems: [],
      totalAmount: 0,
      availableProducts: [],
      loading: true,
      selectedProductId: "",
      selectedQuantity: 1,
      processing: false,
      showPixDialog: false,
      pixData: null,
      paymentId: null,
      paymentConfirmed: false,
      awaitingPayment: false,
      addressValid: false,
      selectedAddressData: null,
      useAutocomplete: true, // Feature flag for address autocomplete - ATIVADO
    };

    const publicKey = process.env.REACT_APP_MERCADO_PAGO_PUBLIC_KEY;
    try {
      if (publicKey) {
        this.mercadoPagoService = new MercadoPagoService(publicKey);
      } else {
        console.warn('REACT_APP_MERCADO_PAGO_PUBLIC_KEY not configured');
      }
    } catch (error) {
      console.error('Error initializing Mercado Pago Service:', error);
    }
  }

  componentDidMount() {
    this.loadProducts();
  }

  componentWillUnmount() {
    const organizationId = process.env.REACT_APP_ORGANIZATION_ID;
    if (organizationId && this.props.firebase) {
      this.props.firebase.products(organizationId).off();
    }
  }

  loadProducts = () => {
    const organizationId = process.env.REACT_APP_ORGANIZATION_ID;
    
    console.log('Loading products for organization:', organizationId);
    
    if (!organizationId) {
      console.error('REACT_APP_ORGANIZATION_ID not configured');
      NotificationManager.error('Configuração de organização não encontrada');
      this.setState({ loading: false });
      return;
    }

    if (!this.props.firebase) {
      console.error('Firebase not initialized');
      NotificationManager.error('Erro ao conectar com o banco de dados');
      this.setState({ loading: false });
      return;
    }

    // Buscar produtos diretamente do Firebase
    this.props.firebase
      .products(organizationId)
      .on('value', (snapshot) => {
        console.log('Firebase snapshot received:', snapshot.val());
        const productsObject = snapshot.val();
        
        if (productsObject) {
          const productsList = Object.keys(productsObject).map((key) => ({
            id: key,
            ...productsObject[key],
          }));
          
          console.log('Products loaded:', productsList.length);
          
          // Ordenar por descrição
          productsList.sort((a, b) => 
            (a.description || '').localeCompare(b.description || '')
          );
          
          this.setState({ 
            availableProducts: productsList, 
            loading: false 
          });
        } else {
          console.log('No products found');
          NotificationManager.warning('Nenhum produto disponível no momento');
          this.setState({ availableProducts: [], loading: false });
        }
      }, (error) => {
        console.error('Firebase error:', error);
        NotificationManager.error('Erro ao carregar produtos: ' + error.message);
        this.setState({ loading: false });
      });
  };

  handleAddProduct = () => {
    const { selectedProductId, selectedQuantity, cartItems, availableProducts } = this.state;

    if (!selectedProductId || selectedQuantity <= 0) {
      NotificationManager.error("Selecione um produto e quantidade válida");
      return;
    }

    const product = availableProducts.find((p) => p.id === selectedProductId);
    if (!product) return;

    const existingItem = cartItems.find((item) => item.productId === selectedProductId);

    let updatedCart;
    if (existingItem) {
      updatedCart = cartItems.map((item) =>
        item.productId === selectedProductId
          ? { ...item, quantity: item.quantity + selectedQuantity }
          : item
      );
    } else {
      updatedCart = [
        ...cartItems,
        {
          productId: selectedProductId,
          productName: product.description,
          price: product.cash || 0,
          quantity: selectedQuantity,
        },
      ];
    }

    this.setState(
      {
        cartItems: updatedCart,
        selectedProductId: "",
        selectedQuantity: 1,
      },
      () => this.calculateTotal()
    );
  };

  handleRemoveProduct = (productId) => {
    const updatedCart = this.state.cartItems.filter(
      (item) => item.productId !== productId
    );
    this.setState({ cartItems: updatedCart }, () => this.calculateTotal());
  };

  // Adiciona 1 unidade do produto ao carrinho
  handleQuickAddProduct = (product) => {
    const { cartItems } = this.state;
    const existingItem = cartItems.find((item) => item.productId === product.id);

    let updatedCart;
    if (existingItem) {
      updatedCart = cartItems.map((item) =>
        item.productId === product.id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      );
    } else {
      updatedCart = [
        ...cartItems,
        {
          productId: product.id,
          productName: product.description,
          price: product.cash || 0,
          quantity: 1,
        },
      ];
    }

    this.setState({ cartItems: updatedCart }, () => this.calculateTotal());
  };

  // Remove 1 unidade do produto do carrinho
  handleQuickRemoveProduct = (productId) => {
    const { cartItems } = this.state;
    const existingItem = cartItems.find((item) => item.productId === productId);

    if (!existingItem) return;

    let updatedCart;
    if (existingItem.quantity === 1) {
      // Remove o item completamente se quantidade é 1
      updatedCart = cartItems.filter((item) => item.productId !== productId);
    } else {
      // Decrementa a quantidade
      updatedCart = cartItems.map((item) =>
        item.productId === productId
          ? { ...item, quantity: item.quantity - 1 }
          : item
      );
    }

    this.setState({ cartItems: updatedCart }, () => this.calculateTotal());
  };

  // Retorna a quantidade de um produto no carrinho
  getProductQuantityInCart = (productId) => {
    const item = this.state.cartItems.find((item) => item.productId === productId);
    return item ? item.quantity : 0;
  };

  calculateTotal = () => {
    const totalAmount = this.state.cartItems.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0
    );
    this.setState({ totalAmount });
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleSelectChange = (event) => {
    this.setState({ selectedProductId: event.target.value });
  };

  handleQuantityChange = (event) => {
    this.setState({ selectedQuantity: parseInt(event.target.value) || 1 });
  };

  // Limpa a máscara do telefone, mantendo apenas números
  cleanPhoneNumber = (phone) => {
    return phone.replace(/\D/g, '');
  };

  // Valida se o telefone tem o formato correto
  // Aceita apenas celular (11 dígitos: DDD + 9 dígitos)
  validatePhoneNumber = (phone) => {
    const cleaned = this.cleanPhoneNumber(phone);
    return cleaned.length === 11;
  };

  closePixDialog = () => {
    this.setState({ showPixDialog: false, awaitingPayment: false });
  };

  handleAddressSelect = (addressData) => {
    console.log("Address selected:", addressData);
    this.setState({
      address: addressData.address,
      selectedAddressData: addressData,
    });
  };

  handleAddressValidation = (isValid, areaName) => {
    console.log("Address validation:", isValid, areaName);
    this.setState({ addressValid: isValid });
  };

  handleCheckout = async () => {
    const { phonenumber, address, cartItems, useAutocomplete, addressValid } = this.state;

    if (!phonenumber.trim()) {
      NotificationManager.error("Telefone é obrigatório");
      return;
    }

    if (!this.validatePhoneNumber(phonenumber)) {
      NotificationManager.error("Celular inválido. Use o formato (DD) 9XXXX-XXXX");
      return;
    }

    if (!address.trim()) {
      NotificationManager.error("Endereço é obrigatório");
      return;
    }

    // If using autocomplete, validate the address
    if (useAutocomplete && !addressValid) {
      NotificationManager.error(
        "Por favor, selecione um endereço válido dentro da nossa área de entrega"
      );
      return;
    }

    if (cartItems.length === 0) {
      NotificationManager.error("Adicione pelo menos um produto ao carrinho");
      return;
    }

    // TODO: Integrar Mercado Pago para pagamento via Pix
    this.initiatePixPayment();
  };

  initiatePixPayment = async () => {
    if (!this.mercadoPagoService) {
      NotificationManager.error("Serviço de pagamento não está configurado");
      return;
    }

    this.setState({ processing: true });

    try {
      const { phonenumber, address, complement, cartItems, totalAmount } = this.state;
      const organizationId = process.env.REACT_APP_ORGANIZATION_ID;

      if (!organizationId) {
        NotificationManager.error("Erro: Organização não configurada");
        this.setState({ processing: false });
        return;
      }

      // Limpar telefone antes de enviar (remover máscara e espaços)
      const cleanedPhone = this.cleanPhoneNumber(phonenumber);

      // Dados para enviar ao backend
      const orderData = {
        phonenumber: cleanedPhone,
        address,
        complement,
        products: cartItems,
        total_amount: totalAmount,
        payment_method: "PIX",
        organization_id: organizationId,
      };

      // Criar pagamento via Mercado Pago
      NotificationManager.info("Gerando QR Code Pix...");
      const paymentData = await this.mercadoPagoService.createPixPayment(
        orderData
      );

      // Exibir QR Code em dialog
      this.setState({
        showPixDialog: true,
        pixData: {
          qrCode: paymentData.qrCode || paymentData.ticketUrl,
          qr_code_base64: paymentData.qr_code_base64,
          qr_code: paymentData.qr_code,
          orderId: paymentData.orderId,
          paymentId: paymentData.paymentId,
          preferenceId: paymentData.preferenceId,
        },
        preferenceId: paymentData.preferenceId,
        awaitingPayment: true,
        processing: false,
      });

      // Aguardar confirmação do pagamento via polling
      NotificationManager.info(
        'Aguardando confirmação do pagamento...'
      );
      
      // Verificar status do pagamento a cada 2 segundos
      this.waitForPaymentConfirmation(paymentData.paymentId);
    } catch (error) {
      NotificationManager.error(
        "Erro ao gerar QR Code: " + error.message
      );
      this.setState({ processing: false });
    }
  };

  waitForPaymentConfirmation = async (paymentId) => {
    try {
      const confirmed = await this.mercadoPagoService.waitForPaymentConfirmation(
        paymentId,
        120, // Máximo 2 minutos
        1000 // Verificar a cada 1 segundo
      );

      if (confirmed) {
        this.setState({ 
          paymentConfirmed: true, 
          awaitingPayment: false,
          paymentId: paymentId // Salvar paymentId para usar em completeOrder
        });
        NotificationManager.success("Pagamento confirmado!");
        setTimeout(() => {
          this.completeOrder();
        }, 1500);
      } else {
        this.setState({ awaitingPayment: false });
        NotificationManager.warning(
          "Pagamento não confirmado. Tente novamente."
        );
      }
    } catch (error) {
      this.setState({ awaitingPayment: false });
      NotificationManager.error(
        "Erro ao verificar pagamento: " + error.message
      );
    }
  };

  completeOrder = () => {
    const { paymentId } = this.state;
    const organizationId = process.env.REACT_APP_ORGANIZATION_ID;

    if (!organizationId) {
      NotificationManager.error("Erro: Organização não configurada");
      return;
    }

    console.log('Aguardando webhook criar pedido para payment ID:', paymentId);
    
    // Aguardar o webhook criar o pedido no Firebase
    this.waitForOrderCreation(organizationId, paymentId);
  };

  waitForOrderCreation = (organizationId, paymentId) => {
    NotificationManager.info("Processando pedido...");
    
    // Garantir que paymentId seja string
    const paymentIdStr = String(paymentId);
    
    console.log('Aguardando webhook criar pedido para:', {
      organizationId,
      paymentId: paymentIdStr,
      path: `organizations/${organizationId}/orders`
    });
    
    let attempts = 0;
    const maxAttempts = 30; // 30 segundos máximo
    
    const checkOrder = () => {
      attempts++;
      
      console.log(`Tentativa ${attempts}/${maxAttempts} - Buscando pedido com payment_id: ${paymentIdStr}`);
      
      // Buscar pedido pelo payment_id
      this.props.firebase
        .orders(organizationId)
        .orderByChild('payment_id')
        .equalTo(paymentIdStr)
        .once('value')
        .then((snapshot) => {
          const orders = snapshot.val();
          
          console.log('Resultado da busca:', {
            orders,
            hasOrders: !!orders,
            attempt: attempts
          });
          
          if (orders) {
            // Pedido encontrado! Usar a chave do Firebase (não o campo id interno)
            const firebaseKey = Object.keys(orders)[0];
            const orderData = orders[firebaseKey];
            
            console.log('Pedido criado pelo webhook:', {
              firebaseKey,
              internalId: orderData.id,
              paymentId: orderData.payment_id
            });
            
            // Usar a chave do Firebase como orderId
            const orderId = firebaseKey;
            
            // Limpar estado e redirecionar
            this.setState(
              {
                processing: false,
                showPixDialog: false,
                phonenumber: "",
                address: "",
                complement: "",
                cartItems: [],
                totalAmount: 0,
                selectedProductId: "",
                selectedQuantity: 1,
                pixData: null,
                paymentId: null,
                paymentConfirmed: false,
              },
              () => {
                NotificationManager.success("Pedido criado com sucesso!");
                // Redirecionar para tela de tracking
                this.props.history.push(`/order-tracking/${organizationId}/${orderId}`);
              }
            );
          } else if (attempts < maxAttempts) {
            // Ainda não foi criado, tentar novamente em 1 segundo
            setTimeout(checkOrder, 1000);
          } else {
            // Timeout - webhook não criou o pedido
            console.error('Timeout esperando webhook criar pedido');
            NotificationManager.warning(
              "Pedido está sendo processado. Verifique sua lista de pedidos em instantes."
            );
            this.setState({
              processing: false,
              showPixDialog: false,
              phonenumber: "",
              address: "",
              complement: "",
              cartItems: [],
              totalAmount: 0,
              selectedProductId: "",
              selectedQuantity: 1,
              pixData: null,
              paymentId: null,
              paymentConfirmed: false,
            });
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar pedido:', error);
          if (attempts < maxAttempts) {
            setTimeout(checkOrder, 1000);
          } else {
            NotificationManager.error("Erro ao processar pedido");
            this.setState({ processing: false });
          }
        });
    };
    
    // Iniciar verificação
    checkOrder();
  };

  render() {
    const {
      classes,
    } = this.props;
    const {
      phonenumber,
      address,
      complement,
      cartItems,
      totalAmount,
      availableProducts,
      selectedProductId,
      selectedQuantity,
      processing,
      showPixDialog,
      pixData,
      awaitingPayment,
      paymentConfirmed,
      useAutocomplete,
    } = this.state;

    return (
      <Box className={classes.root}>
        <Container className={`${classes.container} ${classes.contentPadding}`}>
          {/* Informações do Cliente */}
          <Paper className={classes.paper}>
            <Typography className={classes.sectionTitle}>
              <span role="img" aria-label="informações">📋</span> Informações de Entrega
            </Typography>

            <InputMask
              mask="(99) 99999-9999"
              value={phonenumber}
              onChange={this.handleInputChange}
            >
              {(inputProps) => (
                <TextField
                  {...inputProps}
                  name="phonenumber"
                  placeholder="(85) 98738-7795"
                  label="Celular *"
                  variant="outlined"
                  fullWidth
                  className={classes.textField}
                  type="tel"
                />
              )}
            </InputMask>

            {useAutocomplete ? (
              <Box className={classes.textField}>
                <AddressAutocomplete
                  firebase={this.props.firebase}
                  organizationId={process.env.REACT_APP_ORGANIZATION_ID}
                  onAddressSelect={this.handleAddressSelect}
                  onValidationChange={this.handleAddressValidation}
                  label="Endereço *"
                  placeholder="Digite seu endereço completo..."
                />
              </Box>
            ) : (
              <TextField
                name="address"
                value={address}
                onChange={this.handleInputChange}
                placeholder="Rua, número"
                label="Endereço *"
                variant="outlined"
                fullWidth
                className={classes.textField}
              />
            )}

            <TextField
              name="complement"
              value={complement}
              onChange={this.handleInputChange}
              placeholder="Apto, complemento (opcional)"
              label="Complemento"
              variant="outlined"
              fullWidth
              className={classes.textField}
            />
          </Paper>

          {/* Seleção de Produtos */}
          <Paper className={classes.paper} style={{ marginTop: 24 }}>
            <Typography className={classes.sectionTitle}>
              <span role="img" aria-label="produtos">🛍️</span> Selecione os Produtos
            </Typography>

            <Grid container spacing={2} className={classes.productGrid}>
              {availableProducts.map((product) => {
                const quantityInCart = this.getProductQuantityInCart(product.id);
                return (
                  <Grid item xs={12} sm={6} md={4} key={product.id}>
                    <Card
                      className={`${classes.productCard} ${
                        quantityInCart > 0 ? classes.productCardSelected : ""
                      }`}
                    >
                      <CardContent className={classes.productCardContent}>
                        <Box className={classes.productInfo}>
                          <Typography variant="h6">{product.description}</Typography>
                          <Typography variant="body2" color="textSecondary">
                            R$ {parseFloat(product.cash || 0).toFixed(2)}
                          </Typography>
                        </Box>
                        
                        <Box className={classes.productActions}>
                          {quantityInCart > 0 ? (
                            // Mostra controles de quantidade se já está no carrinho
                            <Box className={classes.quantityControl}>
                              <IconButton
                                size="small"
                                className={classes.quantityButton}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.handleQuickRemoveProduct(product.id);
                                }}
                              >
                                <RemoveIcon fontSize="small" />
                              </IconButton>
                              <Typography className={classes.quantityText}>
                                {quantityInCart}
                              </Typography>
                              <IconButton
                                size="small"
                                className={classes.quantityButton}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.handleQuickAddProduct(product);
                                }}
                              >
                                <AddIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          ) : (
                            // Mostra botão de adicionar se não está no carrinho
                            <IconButton
                              className={classes.addButton}
                              onClick={(e) => {
                                e.stopPropagation();
                                this.handleQuickAddProduct(product);
                              }}
                              aria-label="adicionar ao carrinho"
                            >
                              <AddIcon />
                            </IconButton>
                          )}
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>

            {selectedProductId && (
              <Box style={{ marginTop: 16, padding: 16, background: "#f0f0f0", borderRadius: 8 }}>
                <FormControl fullWidth style={{ marginBottom: 16 }}>
                  <InputLabel>Quantidade</InputLabel>
                  <Select
                    value={selectedQuantity}
                    onChange={this.handleQuantityChange}
                  >
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((qty) => (
                      <MenuItem key={qty} value={qty}>
                        {qty}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddShoppingCartIcon />}
                  fullWidth
                  onClick={this.handleAddProduct}
                >
                  Adicionar ao Carrinho
                </Button>
              </Box>
            )}
          </Paper>



          {/* PIX Payment Dialog */}
          <Dialog
            open={showPixDialog}
            onClose={this.closePixDialog}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>
              <span role="img" aria-label="pix">💳</span> Pague com Pix
            </DialogTitle>
            <DialogContent style={{ textAlign: "center", padding: 24 }}>
              {awaitingPayment && !paymentConfirmed && (
                <>
                  {pixData && (pixData.qr_code_base64 || pixData.qrCode) ? (
                    <>
                      {pixData.qr_code_base64 ? (
                        // Se temos o QR code base64, mostramos a imagem
                        <>
                          <Typography variant="body2" style={{ marginBottom: 16 }}>
                            Escaneie o QR Code para pagar:
                          </Typography>
                          <Box
                            style={{
                              background: "#f9f9f9",
                              padding: 16,
                              borderRadius: 8,
                              marginBottom: 16,
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center'
                            }}
                          >
                            <img 
                              src={`data:image/png;base64,${pixData.qr_code_base64}`}
                              alt="QR Code PIX"
                              style={{ width: '280px', height: '280px', marginBottom: 16 }}
                            />
                            
                            {pixData.qr_code && (
                              <>
                                <Typography variant="body2" style={{ marginBottom: 8 }}>
                                  Ou copie o código PIX:
                                </Typography>
                                <TextField
                                  fullWidth
                                  multiline
                                  rows={3}
                                  value={pixData.qr_code}
                                  InputProps={{
                                    readOnly: true,
                                    style: { fontSize: '0.75rem' }
                                  }}
                                  style={{ marginBottom: 16 }}
                                />
                                <Button
                                  variant="outlined"
                                  fullWidth
                                  onClick={() => {
                                    navigator.clipboard.writeText(pixData.qr_code);
                                  }}
                                >
                                  Copiar Código PIX
                                </Button>
                              </>
                            )}
                          </Box>
                        </>
                      ) : (
                        // Se não temos base64, mostramos o botão com link
                        <>
                          <Typography variant="body2" style={{ marginBottom: 16 }}>
                            Clique no botão abaixo para abrir o Mercado Pago e pagar com PIX:
                          </Typography>
                          <Box
                            style={{
                              background: "#f9f9f9",
                              padding: 16,
                              borderRadius: 8,
                              marginBottom: 16,
                            }}
                          >
                            <Button
                              variant="contained"
                              color="primary"
                              fullWidth
                              href={pixData.qrCode}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginBottom: 16 }}
                            >
                              Abrir Mercado Pago para Pagar
                            </Button>
                            {pixData.preferenceId && (
                              <Typography
                                variant="caption"
                                style={{
                                  wordBreak: "break-all",
                                  fontSize: "0.75rem",
                                  color: "#666",
                                }}
                              >
                                ID: {pixData.preferenceId}
                              </Typography>
                            )}
                          </Box>
                        </>
                      )}
                      
                      <Box style={{ marginTop: 24 }}>
                        <CircularProgress size={40} />
                        <Typography variant="body2" style={{ marginTop: 16 }}>
                          Aguardando confirmação do pagamento...
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          Após realizar o pagamento, seu pedido será criado automaticamente
                        </Typography>
                      </Box>
                    </>
                  ) : (
                    <>
                      <CircularProgress />
                      <Typography variant="body2" style={{ marginTop: 16 }}>
                        Gerando link de pagamento...
                      </Typography>
                    </>
                  )}
                </>
              )}
              {paymentConfirmed && (
                <>
                  <Typography
                    variant="h6"
                    style={{
                      color: "green",
                      marginBottom: 16,
                    }}
                  >
                    <span role="img" aria-label="sucesso">✅</span> Pagamento Confirmado!
                  </Typography>
                  <Typography variant="body2">
                    Seu pedido está sendo processado.
                  </Typography>
                </>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.closePixDialog}
                color="default"
                disabled={awaitingPayment}
              >
                Fechar
              </Button>
            </DialogActions>
          </Dialog>
        </Container>

        {/* Fixed Bottom Payment Button */}
        <Box className={classes.fixedBottomBar}>
          <Container className={classes.container}>
            <Button
              className={classes.fixedBottomButton}
              variant="contained"
              fullWidth
              disabled={processing || cartItems.length === 0}
              onClick={this.handleCheckout}
            >
              <span>{processing ? "Processando..." : "Pagar com Pix"}</span>
              <span style={{ fontWeight: "bold", fontSize: "1.3rem" }}>
                R$ {totalAmount.toFixed(2)}
              </span>
            </Button>
          </Container>
        </Box>
      </Box>
    );
  }
}

const CustomerCheckout = compose(withStyles(styles), withFirebase)(
  CustomerCheckoutBase
);

export { CustomerCheckoutBase };
export default CustomerCheckout;
